module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud02.b343b9d2fb52f9f65e8798c2176c8547.png";